module.exports = __webpack_public_path__ + "static/media/widget-four.49c367c0.png";